import axios from 'axios';

export default{
    getCareers(){
        return axios.get('https://backwp.aipath.gr/wp-json/aipath/v1/get-careers');
    }
}